import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  SelectContainer,
  SelectContainer2,
  RowSelect,
  Button,
  Container,
  SubTitle,
  ButtonSelect,
} from "./InputPassObjects.styled";

const InputPassObjectsView = (props) => {
  const { t } = useTranslation();
  const {
    objects,
    objectsSelected,
    filter,
    onSelectObject,
    onSelectAll,
    onDeleteObject,
    onDeleteAll,
    filterObjects,
    objectsBack,
    renderField,
  } = props;

  const [searchValue, setSearchValue] = useState("");

  // Sincronizar searchValue con filter cuando se resetea externamente
  useEffect(() => {
    if (filter === "") {
      setSearchValue("");
    }
  }, [filter]);

  const renderObjectsAllowed = () => {
    return objectsBack.map((object) => {
      return (
        <div className="row  no-margin" key={`allow_${object.uuid}`}>
          <div className="col-12">
            <RowSelect>
              <div>{renderField(object)}</div>
              <Button type="button" onClick={() => onSelectObject(object)}>
                <i className="fa-solid fa-square-plus"></i>
              </Button>
            </RowSelect>
          </div>
        </div>
      );
    });
  };

  const renderObjectsSelected = () => {
    return objectsSelected.map((object) => {
      return (
        <div className="row no-margin" key={`selected_${object.uuid}`}>
          <div className="col-12">
            <RowSelect>
              <div>{renderField(object)}</div>
              <Button type="button" onClick={() => onDeleteObject(object)}>
                <i className="fa-solid fa-square-minus"></i>
              </Button>
            </RowSelect>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="col-12">
        <div className="row mb-3">
          <div className="col-6">
            <div className="d-flex gap-2">
              <input
                className="form-control"
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    filterObjects(searchValue);
                  }
                }}
                placeholder={`Search...`}
                type="text"
                value={searchValue}
              />
              <button
                className="btn btn-primary"
                onClick={() => filterObjects(searchValue)}
                type="button"
              >
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
              {searchValue && (
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setSearchValue("");
                    filterObjects("");
                  }}
                  type="button"
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <SelectContainer>
              <SelectContainer2>
                {objects && renderObjectsAllowed()}
              </SelectContainer2>
            </SelectContainer>
          </div>
          <div className="col-6">
            <SelectContainer>
              <SelectContainer2>
                {objectsSelected && renderObjectsSelected()}
              </SelectContainer2>
            </SelectContainer>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-6 text-end pe-0">
            <ButtonSelect
              type="button"
              onClick={() => onSelectAll()}
              className="me-2"
            >
              <i className="fa-regular fa-square-plus me-1"></i>
              {t("forms.inputPass.buttons.selectAll")}
            </ButtonSelect>
          </div>
          <div className="col-6 text-end pe-0">
            <ButtonSelect
              type="button"
              onClick={() => onDeleteAll()}
              className="me-2"
            >
              <i className="fa-regular fa-trash-can me-1"></i>
              {t("forms.inputPass.buttons.deleteAll")}
            </ButtonSelect>
          </div>
        </div>
      </div>
    </>
  );
};

InputPassObjectsView.propTypes = {
  objects: PropTypes.array.isRequired,
  objectsSelected: PropTypes.array.isRequired,
  filter: PropTypes.string,
  onSelectObject: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onDeleteObject: PropTypes.func.isRequired,
  onDeleteAll: PropTypes.func.isRequired,
  filterObjects: PropTypes.func.isRequired,
  objectsBack: PropTypes.array,
  renderField: PropTypes.func.isRequired,
};

export default InputPassObjectsView;
